export default "__VITE_ASSET__826dbf12__"